const { useManualQuery } = require('graphql-hooks');

const searchUnreadMessageQuery = `query SearchUnreadMessages {
  searchUnreadMessages {
    orders {
      item {
        title
        id
        category_id
        condition
        seller_custom_field
        thumbnail
        permalink
        amazonUrl
      }
      buyer {
          id
          nickname
      }
      id
      order_id
      pack_id
      seller_id
      unit_price
      currency_id
      quantity
      lastUpdated
      dateCreated
      total_amount
      status
      note
      productInfo {
        start_time
        permalink
        sold_quantity
        available_quantity
        catalog_product_id
        seller_custom_field
        id
        title
        category_id
        status
        catalog_listing
        descriptions
        description
        categoryPath
        pictures {
          id
          url
          secure_url
          size
          max_size
          quality
          link
          variant
          width
          height
          id
        }
        shipping {
          mode
          dimensions
          local_pick_up
          free_shipping
          methods
          tags
        }
        attributes {
          name
          value
        }
        tags
        price
        currency_id
        item_relations {
          id
          variation_id
          stock_relation
        }
      }
    }
  }
}`;

const useSearchUnreadMessageManual = () => {
  const [searchUnreadMessages, { loading, error, data }] = useManualQuery(
    searchUnreadMessageQuery
  );

  const { orders } = data
    ? data.searchUnreadMessages
    : { orders: [] };

  return { searchUnreadMessages, loading, error, orders };
};

export { useSearchUnreadMessageManual };
